import LiveSelector from './src/main';

/* istanbul ignore next */
LiveSelector.install = function(Vue) {
  Vue.component(LiveSelector.name, LiveSelector);
};

export default LiveSelector;
